var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Dashboard da Biblioteca","titleIcon":"fas fa-chart-bar"}},[_c('dashboard')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }